
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"30","viewBox":"0 0 24 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1F1F1F","d":"M3.6.7C2 .7.8 2 .8 3.5v22.9c0 1.6 1.3 2.9 2.8 2.9h17.2c1.6 0 2.9-1.3 2.9-2.9V9.3L15.1.7H3.6zm10 10V2.8l7.9 7.9h-7.9z"}})])
          )
        }
      }
    